import React from 'react';
import './PageError.scss';

interface PageErrorProps {
  children: React.ReactNode;
  errorDetails?: string;
}

const PageError = (props: PageErrorProps) => (
  <div className="page-error">
    <div className={'page-error__container'}>
      {props.children}
      <div className={'page-error__details'}>
        <code>
          {props.errorDetails}
        </code>
      </div>
    </div>
  </div>
);

export default PageError;
